// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"bcda7566","520":"029cb0a6","526":"8684f1e2","559":"cb25e865","580":"856d8207","648":"31c95fdf","706":"7c30e0cf","734":"6546b185","768":"be9e6954","925":"9524ac93","975":"79359508","993":"50911cd4"}[chunkId] + ".chunk.js";
};